import { theme as chakraTheme } from "@chakra-ui/core";

export const theme = {
  ...chakraTheme,
  breakpoints: ["30em", "48em", "62em", "80em"]
};
